<template>
  <div class="container-choosecards">
    <div class="regist-item kor-card pdb-7 mb-7" v-if="userStore.userInfo.countryCode === 'KR'">
      <button type="button" class="regist-btn" @click="handleCardAdd('TOSS')">
        <div class="card-img mb-3">
          <img src="/images/kor-card.svg" alt="" />
        </div>
        <p class="strong">
          <i18n-t keypath="confirm_payment_with_card" scope="global">
            <template #cardType>
              <span class="primary">{{ t('ss_label_card_korean') }}</span>
            </template>
          </i18n-t>
        </p>
        <div class="fake-btn flex-center">
          <span>{{ t('register_korean_card') }}</span>
          <IconArrow class="icon" />
        </div>
      </button>
    </div>

    <div class="regist-item oversea-card mb-3">
      <button type="button" class="regist-btn" @click="handleCardAdd('STRIPE')">
        <div class="card-img mb-3">
          <img src="/images/oversea-card.svg" alt="" />
        </div>
        <p class="strong">
          <i18n-t keypath="confirm_payment_with_card" scope="global">
            <template #cardType>
              <span class="primary">{{ t('card_foreign_some_korean') }}</span>
            </template>
          </i18n-t>
        </p>
        <div class="fake-btn flex-center">
          <span>{{ t('card_manage_register_foreign') }}</span>
          <IconArrow class="icon" />
        </div>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconArrow from '@/components/jh-app/icons/IconArrow.vue';
import { useBrandPay } from '@/composables/domains/self-service/useBrandPay';
import { usePayment } from '@/composables/shared/usePayment';
import { useUserStore } from '@/stores/user';
import { PaymentType } from '@/types/components';

const props = withDefaults(
  defineProps<{
    callback: (cardType?: PaymentType) => void;
  }>(),
  {}
);

const { t } = useI18n();

const userStore = useUserStore();

const { addPaymentMethod } = useBrandPay();
const { openStripeCardAddPopup } = usePayment();

const handleCardAdd = async (cardType: PaymentType) => {
  switch (cardType) {
    case 'TOSS':
      await addPaymentMethod(() => props.callback('TOSS'));
      break;
    case 'STRIPE': {
      const success = await openStripeCardAddPopup();
      if (success) {
        props.callback('STRIPE');
      }
      break;
    }
  }
};
</script>

<style scoped lang="scss">
.container-choosecards {
  .regist-item {
    text-align: center;
    &.kor-card {
      border-bottom: 1px solid $color-gray-40;
      .strong {
        span {
          color: #0aa12d;
        }
      }
    }
    &.oversea-card {
      .strong {
        span {
          color: #363eff;
        }
      }
    }
    .regist-btn {
      display: block;
      width: auto;
      margin: 0 auto;
      .strong {
        font-size: $font-size-h6;
        font-weight: 600;
      }
    }
    .fake-btn {
      span {
        font-size: $font-size-p;
        font-weight: 400;
      }
      svg {
        transform: rotate(90deg);
      }
    }
  }
}
</style>
